import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const GuideTitleMobile = styled(Typography)(() => ({
  fontSize: '20px',
  fontWeight: 500,
  color: 'black',
  textAlign: 'center',
}));
